import { atom } from 'recoil';
export const signUpState = atom({
    key: 'signUpState',
    default: {
        // User related fields
        subCognitoId: null,
        title: '',
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        phoneNumberPlaceHolder: '',
        password: '',
        phoneExt: null,
        logo: null,
        logoBucketKey: null,
        logoFileName: null,
        logoSize: null,
        logoS3Path: null,
        // Client related fields
        clientName: '',
        address: '',
        idCountry: null,
        idState: null,
        idCity: null,
        addressZip: '',
        addressLine2: null,
        phoneError: null,
        // User related errors
        titleError: null,
        firstNameError: null,
        lastNameError: null,
        emailError: null,
        passwordError: null,
        // Client related errors
        clientNameError: null,
        addressError: null,
        addressStateError: null,
        addressZipError: null,
        // Email Confirmation
        confirmationCode: '',
        isUserConfirmed: false,
        // query params
        clientId: '',
        plan: '',
        // Modal
        showModal: false,
        // Form State
        isLoading: false,
        isFormInvalid: true,
        mainError: null,
        dirtyFields: [],
        hearAboutUs: '',
        hearAboutUsError: null,
        confirmTerms: false
    }
});
